import axios from 'axios';

export default {
  get: params => axios.get('/api/v1/gmva/cover-sheet', { params }),
  getPdf: params => axios.get(`/api/v1/gmva/cover-sheet/${params.id}/pdf`),
  create: params => axios.post(`/api/v1/gmva/cover-sheet`, { ...params }),
  getDataForNewSheet: params => axios.get(`/api/v1/gmva/cover-sheet/new-sheet`, { ...params }),
};
